import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "../../../components/Modal/Modal";
import Typography from "../../../components/Typography/Typography";
import Button from "../../../components/Button/Button";
import { Dropdown } from "../../../components/DropDown/DropDown";
import DatePicker from "react-datepicker";
import styled from "styled-components";
import { formatDate } from "../../../utils/common";
import Textarea from "../../../components/TextArea/Textarea";
import Checkbox from "../../../components/CheckBox/CheckBox";
import RadioButton from "../../../components/Radio button/RadioButton";
import { Formik, Field, Form, FormikHelpers } from "formik";
import * as Yup from "yup";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  getReporteesAsync,
  getUserDetailsAsync,
  getUserProfileAsync,
} from "../../../services/reducers/appReducer";
import UserImage from "../../../components/UserImage/UserImage";
import getInitialsInName from "../../../helper/GetNameInitials";
import {
  createTimeoffAsync,
  getLeaveBalanceAsync,
  getLeaveTypeAsync,
} from "../../../services/reducers/leaveReducer";
import { format, differenceInDays } from "date-fns";
import { TOASTIFY_CONF } from "../../../services/sharedService/constants";
import { toast } from "react-toastify";
import SingleMemberDropdownAll from "../ReportingManergerTimeOff/SingleMemberDropdownAll";

export const EchoPulseDatePicker = styled.div`
  overflow: hidden;
  .react-datepicker__calendar-icon {
    display: none;
  }
  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker-wrapper input {
    padding: 0.781rem 0.75rem;
    width: 100%;
    font-size: 0.875rem;
    font-weight: 400;
    color: #232323;
    border: 0.063rem solid #d9d9d9;
    border-radius: 0.375rem;
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z' fill='%23292D32'/%3E%3Cpath d='M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z' fill='%23292D32'/%3E%3Cpath d='M20.5 9.83997H3.5C3.09 9.83997 2.75 9.49997 2.75 9.08997C2.75 8.67997 3.09 8.33997 3.5 8.33997H20.5C20.91 8.33997 21.25 8.67997 21.25 9.08997C21.25 9.49997 20.91 9.83997 20.5 9.83997Z' fill='%23292D32'/%3E%3Cpath d='M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V17C21.75 20.65 19.65 22.75 16 22.75ZM8 4.25C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V8.5C20.25 5.64 18.86 4.25 16 4.25H8Z' fill='%23292D32'/%3E%3Cpath d='M8.5 14.5C8.37 14.5 8.24 14.47 8.12 14.42C8 14.37 7.89001 14.3 7.79001 14.21C7.70001 14.11 7.62999 14 7.57999 13.88C7.52999 13.76 7.5 13.63 7.5 13.5C7.5 13.24 7.61001 12.98 7.79001 12.79C7.89001 12.7 8 12.63 8.12 12.58C8.3 12.5 8.50001 12.48 8.70001 12.52C8.76001 12.53 8.82 12.55 8.88 12.58C8.94 12.6 9 12.63 9.06 12.67C9.11 12.71 9.15999 12.75 9.20999 12.79C9.24999 12.84 9.29999 12.89 9.32999 12.94C9.36999 13 9.40001 13.06 9.42001 13.12C9.45001 13.18 9.47001 13.24 9.48001 13.3C9.49001 13.37 9.5 13.43 9.5 13.5C9.5 13.76 9.38999 14.02 9.20999 14.21C9.01999 14.39 8.76 14.5 8.5 14.5Z' fill='%23292D32'/%3E%3Cpath d='M12 14.5C11.74 14.5 11.48 14.39 11.29 14.21C11.25 14.16 11.21 14.11 11.17 14.06C11.13 14 11.1 13.94 11.08 13.88C11.05 13.82 11.03 13.76 11.02 13.7C11.01 13.63 11 13.57 11 13.5C11 13.37 11.03 13.24 11.08 13.12C11.13 13 11.2 12.89 11.29 12.79C11.57 12.51 12.02 12.42 12.38 12.58C12.51 12.63 12.61 12.7 12.71 12.79C12.89 12.98 13 13.24 13 13.5C13 13.57 12.99 13.63 12.98 13.7C12.97 13.76 12.95 13.82 12.92 13.88C12.9 13.94 12.87 14 12.83 14.06C12.79 14.11 12.75 14.16 12.71 14.21C12.61 14.3 12.51 14.37 12.38 14.42C12.26 14.47 12.13 14.5 12 14.5Z' fill='%23292D32'/%3E%3Cpath d='M8.5 18C8.37 18 8.24 17.97 8.12 17.92C8 17.87 7.89001 17.8 7.79001 17.71C7.70001 17.61 7.62999 17.51 7.57999 17.38C7.52999 17.26 7.5 17.13 7.5 17C7.5 16.74 7.61001 16.48 7.79001 16.29C7.89001 16.2 8 16.13 8.12 16.08C8.49 15.92 8.92999 16.01 9.20999 16.29C9.24999 16.34 9.29999 16.39 9.32999 16.44C9.36999 16.5 9.40001 16.56 9.42001 16.62C9.45001 16.68 9.47001 16.74 9.48001 16.81C9.49001 16.87 9.5 16.94 9.5 17C9.5 17.26 9.38999 17.52 9.20999 17.71C9.01999 17.89 8.76 18 8.5 18Z' fill='%23292D32'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position-x: 97%;
    background-position-y: center;
    cursor: pointer;
  }

  .react-datepicker-wrapper input:focus {
    border: 0.063rem solid #4a154b;
    box-shadow: 0 0.625rem 1.25rem 0 rgba(0, 0, 0, 0.08);
    outline: 0;
  }
  .monthlyDate .react-datepicker-popper {
    width: max-content;
  }
  .monthlyDate .react-datepicker__month-text {
    padding: 0.9rem 0;
    width: 5.1rem;
    display: inline-block;
    font-size: 0.875rem;
    margin: 0.125rem;
  }
  .monthlyDate .react-datepicker__month-text--keyboard-selected {
    background-color: #f8f8f8;
    color: #000;
    font-weight: bolder;
  }
  .monthlyDate .react-datepicker__header {
    background-color: #fff;
    border: none;
    padding-top: 1.25rem;
  }
  .monthlyDate .react-datepicker__navigation {
    align-items: center;
    display: flex;
    padding: 0;
    text-align: center;
    top: 1.063rem;
  }
  .monthlyDate .react-datepicker__navigation--previous {
    left: 0.4375rem;
  }
  .monthlyDate .react-datepicker__navigation--next {
    rigth: 0.4375rem;
  }
  .monthlyDate .react-datepicker__navigation-icon:before {
    border-color: #232323;
    border-width: 0.094rem 0.094rem 0 0;
  }
  .monthlyDate .react-datepicker__day--in-range {
    background-color: #f15845;
  }
  .monthlyDate .react-datepicker__day--keyboard-selected {
    color: #fff;
  }
  .monthlyDate .react-datepicker__day--today {
    font-weight: 800;
  }
  .react-datepicker__month-text--in-range {
    background-color: #f15845;
  }
  .react-datepicker__day--keyboard-selected {
    background-color: #f15845;
  }
  .react-datepicker__day--selected {
    background-color: #f15845;
  }
`;
export const CustomToolTip = styled.div`
  .tooltip {
    position: relative;
    display: inline-block;
    z-index: 9;
    cursor: default;
    width: 100%;
  }

  .tooltiptext {
    visibility: hidden;
    width: 15rem;
    background-color: #fff;
    font-size: 0.75rem;
    font-weight: 500;
    color: #232323;
    text-align: center;
    border-radius: 0.375rem;
    padding: 0.5rem 0.75rem;
    position: absolute;
    z-index: 1;
    top: -1.875rem;
    right: 210%;
    filter: drop-shadow(0 0.5rem 1.5rem rgba(0, 0, 0, 0.12));
  }
  .tooltiptext::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 100%;
    margin-top: -0.625rem;
    border-width: 0.625rem;
    border-style: solid;
    border-color: transparent transparent transparent #fff;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }
`;

type Values = {
  memberId: string;
  leaveCode: string;
  startDate: string;
  endDate: string;
  employeeNote: string;
  requestFor: number;
  leaveBalance: number;
  isConsentChecked: boolean;
  details: {
    timeOffDate: string;
    dayType: number;
    halfDayType: any;
  }[];
  fyId: string;
  leaveId: string;
};

const TimeoffSchema = Yup.object().shape({
  leaveCode: Yup.string().required("Required"),
  //maxLeaves: Yup.string().required("Required"),
});

type Props = {
  onClose: () => void;
  financialyearList?: any;
  setRequestTimeOff: React.Dispatch<React.SetStateAction<boolean>>;
  getSummary?: () => void;
  type?: string;
  tab?: string;
};
const RequestTimeOffModal: React.FC<Props> = ({
  onClose,
  financialyearList,
  setRequestTimeOff,
  getSummary,
  type,
  tab,
}) => {
  const dispatch = useAppDispatch();
  const userProfile = useAppSelector((state: any) => state.app.userProfile);
  const leaveType = useAppSelector((state: any) => state.leave.leaveType);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [selectedHolidayDayType, setSelectedHolidayDayType] = useState<
    number | null
  >(null);
  const [userDetail, setUserDetail] = useState<any>(null);
  const [userIdentity, setUserIdentity] = useState<any>("");
  const [leaveCodeId, setLeaveCodeId] = useState<any>("");
  const [leaveCode, setLeaveCode] = useState<any>("");
  const [leaveCodeValue, setLeaveCodeValue] = useState<number>(0);
  const [totalDaysOff, setTotalDaysOff] = useState<number | null>(null);
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [updatedIndices, setUpdatedIndices] = useState<{
    [key: number]: number;
  }>({});
  const [selectedMember, setSelectedMember] = useState<any>();
  const [searchString, setSearchString] = useState("");
  const [userList, setUserList] = useState<any>(null);
  const activeFinancialYear = financialyearList?.records?.find(
    (record: any) => record.isActive
  );

  const getUserIdentity = () => {
    setLoading(true);
    dispatch(getUserDetailsAsync(userProfile.employeeId)).then((res) => {
      if (res.payload) {
        setUserDetail(res.payload);
        setUserIdentity(res.payload.identityId);
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    getUserIdentity();
    const request: any = {
      Page: 1,
      PageSize: 1000,
      IdentityId: selectedMember ? selectedMember?.identityId : "",
    };
    dispatch(getLeaveTypeAsync(request));
  }, [userProfile, selectedMember]);

  // const handleDateChange = (
  //   date: Date | null,
  //   values: Values,
  //   isStart: boolean
  // ) => {
  //   if (date === null) {
  //     if (isStart) {
  //       setStartDate(null);
  //     } else {
  //       setEndDate(null);
  //     }
  //     setTotalDaysOff(null);
  //   } else {
  //     if (isStart) {
  //       if (endDate && date > endDate) {
  //         setEndDate(null);
  //       }
  //       setStartDate(date);
  //     } else {
  //       if (startDate && date < startDate) {
  //         setStartDate(null);
  //       }
  //       setEndDate(date);
  //     }
  //     const startDates = isStart ? date : startDate;
  //     const endDates = isStart ? endDate : date;
  //     if (startDates && endDates) {
  //       const totalDays = differenceInDays(endDates, startDates) + 1;
  //       setTotalDaysOff(totalDays);
  //     }
  //   }
  // };
  const handleDateChange = (
    date: Date | null,
    values: Values,
    isStart: boolean
  ) => {
    if (date === null) {
      if (isStart) {
        setStartDate(null);
      } else {
        setEndDate(null);
      }
      setTotalDaysOff(null);
    } else {
      if (isStart) {
        if (endDate && date > endDate) {
          setEndDate(null);
        }
        setStartDate(date);
      } else {
        if (startDate && date < startDate) {
          setStartDate(null);
        }
        setEndDate(date);
      }

      const startDates = isStart ? date : startDate;
      const endDates = isStart ? endDate : date;

      if (startDates && endDates) {
        const totalDays = getDates(startDates, endDates).reduce(
          (total, currentDate, idx) => {
            const dayType = values.details[idx]?.dayType ?? 0;
            return total + (dayType === 1 ? 0.5 : 1);
          },
          0
        );
        setTotalDaysOff(totalDays);
      }
    }
  };

  const handleHalfDayTypeChange = (
    value: number,
    index: number,
    setFieldValue: Function,
    values: Values
  ) => {
    const newDetails = [...values.details];
    if (index !== null && index >= 0 && index < newDetails.length) {
      newDetails[index].halfDayType = value;
      setFieldValue(`details`, newDetails);
    }
  };

  const getDates = (startDate: Date, endDate: Date): Date[] => {
    const dates: Date[] = [];
    let currentDate: Date = new Date(startDate);
    while (currentDate <= endDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  };

  const handleHolidayDayTypeChange = (
    value: number,
    values: Values,
    index: number
  ) => {
    const dayType = values.details[index]?.dayType;
    if (
      (dayType !== undefined || value === 1) &&
      updatedIndices[index] !== value &&
      dayType !== value
    ) {
      setSelectedHolidayDayType(value);
      if (value === 1) {
        setTotalDaysOff((prevTotalDays) =>
          prevTotalDays !== null ? prevTotalDays - 0.5 : null
        );
      } else {
        setTotalDaysOff((prevTotalDays) =>
          value === 0 && prevTotalDays !== null
            ? prevTotalDays + 0.5
            : prevTotalDays
        );
      }
      // Update the dictionary with the current index and value combination
      setUpdatedIndices({ ...updatedIndices, [index]: value });
    }
  };

  const dayTypes = [
    { label: "Full", value: 0 },
    { label: "Half", value: 1 },
  ];
  // console.log(totalDaysOff, "total");
  const handleLeaveCodeChange = async (e: any, setFieldValue: Function) => {
    const selectedLeaveCode = e.value;
    const selectedLeaveId = e.id;

    setLeaveCodeId(selectedLeaveId);
    setLeaveCode(selectedLeaveCode);
    setFieldValue("leaveCode", selectedLeaveCode);

    // if (type === "RM" || type === "Admin & RM") {
    if (tab === "tab3") {
      const request: any = {
        identityId: selectedMember ? selectedMember?.identityId : "",
        leaveCode: selectedLeaveCode,
        fyId: activeFinancialYear ? activeFinancialYear.id : "",
        // financialyearList?.records?.length > 0
        //   ? financialyearList?.records[0]?.id
        //   : "",
      };
      const res = await dispatch(getLeaveBalanceAsync(request));
      if (res.payload !== undefined && res.payload !== null) {
        setLeaveCodeValue(res.payload);
      }
    } else {
      const request: any = {
        identityId: userIdentity,
        leaveCode: selectedLeaveCode,
        fyId: activeFinancialYear ? activeFinancialYear.id : "",
        // financialyearList?.records?.length > 0
        //   ? financialyearList?.records[0]?.id
        //   : "",
      };
      const res = await dispatch(getLeaveBalanceAsync(request));
      if (res.payload !== undefined && res.payload !== null) {
        setLeaveCodeValue(res.payload);
      }
    }
  };

  const handleCheckboxChange = (event: any) => {
    setIsChecked(event.target.checked);
  };

  const remainingLeaveBalance =
    leaveCodeValue !== null ? leaveCodeValue - (totalDaysOff ?? 0) : null;

  const calculateMinDate = () => {
    if (leaveCodeId && leaveType && leaveType.records) {
      const selectedLeave = leaveType.records.find(
        (leave: any) => leave.id === leaveCodeId
      );

      if (selectedLeave) {
        return new Date(selectedLeave.startDate);
      }
    }
    return new Date();
  };

  const calculateMaxDate = () => {
    if (leaveCodeId && leaveType && leaveType.records) {
      const selectedLeave = leaveType.records.find(
        (leave: any) => leave.id === leaveCodeId
      );
      if (selectedLeave) {
        return new Date(selectedLeave.endDate);
      }
    }
    return new Date();
  };
  let message = "";

  if (Array.isArray(leaveType.records)) {
    leaveType.records.forEach((record: any) => {
      if (record.leaveCode === leaveCode) {
        if (record.isLeaveSandwitchAllowed) {
          message =
            "Leave Sandwhich policy applicable to this leave type. Weekdays and/or Holidays will be counted for balance deduction.";
        }
      }
    });
  }

  return (
    <Modal isOpen onClose={onClose} placement="right" size="medium">
      <Formik
        enableReinitialize
        initialValues={{
          memberId: "",
          leaveCode: "",
          startDate: "",
          endDate: "",
          employeeNote: "",
          requestFor: 0,
          leaveBalance: 0,
          isConsentChecked: false,
          details: [
            {
              timeOffDate: "",
              dayType: 0,
              halfDayType: null,
            },
          ],
          fyId: "",
          leaveId: "",
        }}
        validationSchema={TimeoffSchema}
        onSubmit={async (
          values: Values,
          { setSubmitting }: FormikHelpers<Values>
        ) => {
          let request: any = values;
          let formattedStartDate = startDate ? formatDate(startDate) : "";
          let formattedEndDate = endDate ? formatDate(endDate) : "";

          let details: any[] = [];
          // if (startDate && endDate) {
          //   details = getDates(startDate, endDate).map((date, index) => {
          //     return {
          //       timeOffDate: formatDate(date),
          //       dayType: values.details[index]?.dayType ?? 0,
          //       halfDayType: values.details[index]?.halfDayType ?? 0,
          //     };
          //   });
          // }
          if (startDate && endDate) {
            details = getDates(startDate, endDate).map((date, index) => {
              const dayType = values.details[index]?.dayType ?? 0;
              return {
                timeOffDate: formatDate(date),
                dayType: dayType,
                ...(dayType === 1 && {
                  halfDayType: values.details[index]?.halfDayType ?? 0,
                }),
              };
            });
          }
          request = {
            ...request,
            startDate: formattedStartDate,
            endDate: formattedEndDate,
            details: details,
            // memberId: selectedMember ? selectedMember?.identityId : "",
            requestFor: totalDaysOff ? totalDaysOff : 0,
            leaveBalance: leaveCodeValue ? leaveCodeValue : 0,
            isConsentChecked: isChecked ? true : false,
            fyId: activeFinancialYear ? activeFinancialYear.id : "",
            // financialyearList?.records?.length > 0
            //   ? financialyearList?.records[0]?.id
            //   : "",
            leaveId: leaveCodeId,
            // isRM: type === "Admin & RM" || type === "RM" ? true : false,
            isRM:
              tab === "tab1"
                ? false
                : tab === "tab3" &&
                  (type === "Admin & RM" || type === "RM" ? true : false),
          };
          if (selectedMember) {
            request.memberId = selectedMember.identityId;
          }
          // console.log(request, "request")
          const result = await dispatch(createTimeoffAsync(request));
          getSummary && getSummary();
          toast.success(
            `Time Off request created successfully!`,
            TOASTIFY_CONF
          );
          setRequestTimeOff(false);
          setSubmitting(false);
        }}
      >
        {({
          errors,
          touched,
          setFieldValue,
          values,
          isSubmitting,
          setFieldTouched,
          submitForm,
          isValid,
          dirty,
        }) => {
          return (
            <Form className="w-full flex flex-col h-full">
              <ModalHeader className="bg-gray-200">
                <Typography className="font-bold text-gray-300" variant="h3">
                  {tab === "tab1" ? "Request Time Off" : "Create Time Off"}
                </Typography>
              </ModalHeader>
              <ModalBody className="!px-0 !overflow-hidden">
                <div className="flex justify-start items-start w-full h-full">
                  <div className="w-[calc(100%-27.938rem)] h-full bg-white ps-20 pe-10 py-10 overflow-auto">
                    <div className="w-full">
                      {/* {type === "RM" || type === "Admin & RM" ? ( */}
                      {tab === "tab3" ? (
                        <>
                          <div className="">
                            <div>
                              <SingleMemberDropdownAll
                                setSelectedMember={setSelectedMember}
                                userList={userList}
                                selectedMember={selectedMember}
                                searchString={searchString}
                                setSearchString={setSearchString}
                                identityId={userIdentity}
                                setUserList={setUserList}
                              />
                            </div>
                          </div>{" "}
                        </>
                      ) : (
                        <>
                          {loading ? (
                            <div className="flex">
                              <svg
                                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="#D9D9D9"
                                  stroke-width="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="#4A154B"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                              </svg>{" "}
                              Loading...
                            </div>
                          ) : (
                            <div className="flex justify-start items-center gap-2.5">
                              <div>
                                {userDetail?.img ? (
                                  <UserImage
                                    imgKey={userDetail?.img}
                                    className="w-8 h-8 rounded-full object-cover"
                                  />
                                ) : (
                                  <img
                                    src={getInitialsInName(
                                      userDetail?.name ?? "N A",
                                      24
                                    )}
                                    alt={userDetail?.name}
                                    className="w-8 h-8 rounded-full object-cover"
                                  />
                                )}
                              </div>
                              <div>
                                <div className="text-600 text-gray-300 font-medium">
                                  {userDetail?.name}
                                </div>
                                <div className="text-500 text-gray-300 font-normal">
                                  {userDetail?.title}
                                  <span className="mx-1.5">|</span>
                                  {userDetail?.team}
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                    <div className="w-full mt-8">
                      <label className="text-400 font-medium text-gray-300 block mb-2">
                        Select Leave Type
                        <span className="text-primary-100 ps-0.5">*</span>
                      </label>
                      <Field
                        name="leaveCode"
                        render={({ field }: any) => (
                          <>
                            <Dropdown
                              onChange={(e: any) =>
                                handleLeaveCodeChange(e, setFieldValue)
                              }
                              options={leaveType?.records?.map((org: any) => ({
                                label: org.title,
                                value: org.leaveCode,
                                id: org.id,
                              }))}
                              type="box"
                              isSearchable={false}
                              placeholder="Select Leave Type"
                            />
                          </>
                        )}
                      />
                    </div>
                    <div className="w-full mt-8">
                      {/* <label className="text-400 font-medium text-gray-300 block mb-2.5">
                        Period
                        <span className="text-primary-100 ps-0.5">*</span>
                      </label> */}
                      <div>
                        <label className="text-400 font-medium text-gray-300 block mb-2">
                          From
                          <span className="text-primary-100 ps-0.5">*</span>
                        </label>
                        <Field
                          name="date"
                          render={({ field }: any) => (
                            <>
                              <EchoPulseDatePicker>
                                <div className="w-full monthlyDate">
                                  <DatePicker
                                    {...field}
                                    dateFormat="dd MMM yyyy"
                                    selected={startDate}
                                    onChange={(date: Date) =>
                                      handleDateChange(date, values, true)
                                    }
                                    minDate={calculateMinDate()}
                                    maxDate={calculateMaxDate()}
                                    placeholderText={"Please Select Start Date"}
                                  />
                                </div>
                              </EchoPulseDatePicker>
                            </>
                          )}
                        />
                      </div>
                      <div className="mt-2.5">
                        <label className="text-400 font-medium text-gray-300 block mb-2">
                          To
                          <span className="text-primary-100 ps-0.5">*</span>
                        </label>
                        <Field
                          name="date"
                          render={({ field }: any) => (
                            <>
                              <EchoPulseDatePicker>
                                <div className="w-full monthlyDate">
                                  <DatePicker
                                    {...field}
                                    dateFormat="dd MMM yyyy"
                                    selected={endDate}
                                    onChange={(date: Date) =>
                                      handleDateChange(date, values, false)
                                    }
                                    minDate={startDate}
                                    maxDate={calculateMaxDate()}
                                    placeholderText={"Please Select End Date"}
                                  />
                                </div>
                              </EchoPulseDatePicker>
                            </>
                          )}
                        />
                      </div>
                    </div>
                    <div className="[&>div>textarea]:h-[8.625rem] mt-8">
                      <label className="text-400 font-medium text-gray-300 block mb-2">
                        Notes (if any)
                      </label>
                      <Field
                        name="employeeNote"
                        render={({ field }: any) => (
                          <>
                            <Textarea
                              placeholder="Add your note"
                              {...field}
                              onChange={(value: string) => {
                                setFieldValue("employeeNote", value);
                              }}
                              resize
                              value={values.employeeNote}
                              maxCharacters={250}
                            />
                          </>
                        )}
                      />
                    </div>
                  </div>
                  {leaveCode !== "RH" && (
                    <div className="w-[27.938rem] h-full bg-gray-200 overflow-auto">
                      <div className="py-10 ps-10 pe-12">
                        {endDate && (
                          <Typography
                            variant="h6"
                            className="font-bold text-gray-300"
                          >
                            Details
                          </Typography>
                        )}
                        {startDate && endDate && (
                          <>
                            <Typography
                              size="lg"
                              variant="p"
                              className="text-gray-700 font-medium mt-2.5"
                            >
                              Selected Dates
                            </Typography>
                            <div>
                              {getDates(startDate, endDate).map(
                                (date, index) => {
                                  return (
                                    <div>
                                      <div
                                        className="flex justify-start items-center gap-4 mt-5"
                                        key={date.toISOString()}
                                      >
                                        <div className="text-500 text-gray-300 font-normal">
                                          {format(date, "dd MMM")}
                                        </div>
                                        <div className="w-[6.375rem]">
                                          <Field
                                            name="dayType"
                                            render={({ field }: any) => (
                                              <>
                                                <Dropdown
                                                  {...field}
                                                  onChange={(e: any) => {
                                                    setFieldValue(
                                                      `details[${index}].dayType`,
                                                      e.value
                                                    );
                                                    handleHolidayDayTypeChange(
                                                      e.value,
                                                      values,
                                                      index
                                                    );
                                                  }}
                                                  options={dayTypes}
                                                  type="box"
                                                  isSearchable={false}
                                                  value={dayTypes.find(
                                                    (option) =>
                                                      option.value ===
                                                      (values.details[index]
                                                        ?.dayType ?? 0)
                                                  )}
                                                />
                                              </>
                                            )}
                                          />
                                        </div>
                                        <div>day</div>
                                      </div>
                                      {values.details[index]?.dayType === 1 && (
                                        <div className="mt-5">
                                          <label className="text-400 font-medium text-gray-300 block mb-2">
                                            Select Half day period
                                          </label>
                                          <div className="flex justify-start items-center gap-6">
                                            <Field
                                              type="radio"
                                              name={`halfDayType-${index}`}
                                              value={0}
                                              render={({ field }: any) => (
                                                <RadioButton
                                                  label="First Half"
                                                  {...field}
                                                  onChange={() =>
                                                    handleHalfDayTypeChange(
                                                      0,
                                                      index,
                                                      setFieldValue,
                                                      values
                                                    )
                                                  }
                                                  selectedValue={
                                                    values.details[index]
                                                      ?.halfDayType ?? 0
                                                  }
                                                />
                                              )}
                                            />
                                            <Field
                                              type="radio"
                                              name={`halfDayType-${index}`}
                                              value={1}
                                              render={({ field }: any) => (
                                                <RadioButton
                                                  label="Second Half"
                                                  {...field}
                                                  onChange={() =>
                                                    handleHalfDayTypeChange(
                                                      1,
                                                      index,
                                                      setFieldValue,
                                                      values
                                                    )
                                                  }
                                                  selectedValue={
                                                    values.details[index]
                                                      ?.halfDayType
                                                  }
                                                />
                                              )}
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </>
                        )}
                        {totalDaysOff && endDate && (
                          <div className="text-600 text-gray-300 font-bold mt-12">
                            Requesting :{" "}
                            {totalDaysOff !== null && endDate
                              ? `${totalDaysOff} ${
                                  totalDaysOff !== null && totalDaysOff > 1
                                    ? "Days"
                                    : "Day"
                                }`
                              : "Calculating..."}
                          </div>
                        )}

                        {!(leaveCode === "LOP") && (
                          <div className="text-500 text-gray-300 font-normal mt-4">
                            {values.leaveCode &&
                              leaveCodeValue !== null &&
                              (leaveCodeValue > 0
                                ? `Leave Balance: ${leaveCodeValue} ${
                                    leaveCodeValue > 1 ? "Days" : "Day"
                                  }`
                                : leaveCodeValue < 0
                                ? " Leave Balance: Exhausted"
                                : leaveCodeValue === 0
                                ? `Leave Balance: ${leaveCodeValue} Day(s)`
                                : "")}
                          </div>
                        )}

                        {values.leaveCode &&
                        leaveCodeValue !== null &&
                        leaveCodeValue < 0.5 ? (
                          <div className="text-error font-primary mt-2 text-200">
                            Warning: Since the selected leave type has balance
                            less than 0.5 day, your leave will be marked as loss
                            of pay or you can change the leave type in order to
                            proceed.
                          </div>
                        ) : (
                          remainingLeaveBalance !== null &&
                          remainingLeaveBalance < 0 &&
                          endDate && (
                            <div className="text-error font-primary mt-2 text-200">
                              Warning: Your leave balance is low. Please
                              consider taking unpaid leave.
                            </div>
                          )
                        )}
                        {remainingLeaveBalance !== null &&
                          remainingLeaveBalance < 0 &&
                          endDate && (
                            <div className="mt-5 flex justify-start items-center gap-2.5">
                              <Checkbox
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                              />
                              <div className="text-400 text-gray-300 font-normal">
                                I hereby consent with an unpaid duration for my{" "}
                                {leaveCodeValue < 0.5
                                  ? totalDaysOff
                                  : Math.abs(remainingLeaveBalance).toFixed(
                                      2
                                    )}{" "}
                                day(s) period of leave.
                              </div>
                            </div>
                          )}
                        {message && (
                          <div className="text-500 text-gray-300 font-normal mt-4">
                            <b>Note </b>: {message}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </ModalBody>
              <ModalFooter>
                <div className="flex justify-start gap-5">
                  <Button
                    label="Send Request"
                    variant="primary"
                    size="large"
                    isDisabled={
                      isSubmitting ||
                      !isValid ||
                      !dirty ||
                      startDate === null ||
                      endDate === null ||
                      (tab === "tab3" &&
                        // ((type === "RM" || type === "Admin & RM") &&
                        !selectedMember) ||
                      (leaveCode !== "RH" &&
                        remainingLeaveBalance !== null &&
                        remainingLeaveBalance < 0 &&
                        !isChecked)
                    }
                  />
                  <Button
                    label="Cancel"
                    onClick={onClose}
                    variant="outline"
                    size="large"
                  />
                </div>
              </ModalFooter>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default RequestTimeOffModal;
